namespace GeniuzPOS.Administration {
    export interface CsVatCodeForm {
        VatCode: Serenity.StringEditor;
        VatRate: Serenity.DecimalEditor;
    }

    export class CsVatCodeForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.CsVatCode';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsVatCodeForm.init)  {
                CsVatCodeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(CsVatCodeForm, [
                    'VatCode', w0,
                    'VatRate', w1
                ]);
            }
        }
    }
}
